<div *ngIf="spinner==true">
    <ngx-spinner size="medium" type="timer">
        <p style="font-size: 20px; color: white;padding-left:7%;">Loading...</p>
    </ngx-spinner>
</div>
<div class="container-fluid">
    <div class="card">
        <div class="card-header">
            <div class="d-flex justify-content-between">
                <h4 class="font-weight-bold text-dark py">ACTIVITY SUMMARY</h4>
             
            </div>

        </div>
       
        <div class="form-group row" style="padding-left: 20px;">
            <div class="col-md-6">
               <label class="form-label">Select Activity<span class="required">*</span></label>
               <select class="form-control" #myval (change)="handleChange(myval.value)" >
                <option value="" selected disabled hidden>Select Activity/Task</option>
                <option *ngFor="let option of activities" [value]="option['id']">
                    {{option['activity']}}</option>

               </select>
            </div>
        </div>
        <div class="p-3">
            <div class="table-responsive" *ngIf="tableshow">
                <table class="table table-bordered display" [dtOptions]="dtOptions" datatable width="100%"
                    cellspacing="0">
                    <thead>
                        <tr>
                            <th>FirstName</th>
                            <th>Email</th>
                            <th>LastName</th>
                            <th>District</th>
                            <th>Constituency</th>
                            <th>Status</th>
                            <th>Show</th>
                         
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngFor="let customer of customers">
                            <td style="min-width: 20px;">
                                {{customer.firstname}}
                            </td>
                            <!-- <td style="min-width: 20px;">
                            {{customer.designation}}
                            </td> -->
                            <!-- <td style="min-width: 20px;">
                            {{customer.applied_role}}
                            </td> -->
                            <!-- <td style="min-width: 20px;">
                            {{customer.approval_status}}
                            </td> -->
                            <td style="min-width: 20px;">
                                {{customer.email}}
                            </td>
                            <td style="min-width: 20px;">
                                {{customer.lastname }}
                            </td>
                            <td style="min-width: 20px;">
                                {{customer.district}}
                            </td>
                            <td style="min-width: 20px;">
                                {{customer.constituency}}
                            </td>
                            <td style="min-width: 20px;">
                                {{customer.status}}
                            </td>

                            <td><a data-toggle="modal" data-target="#showCM" class="btn btn-primary btn-circle btn-sm"
                                    (click)="buttonviewmeeting(customer,'show')">
                                    <i class="fas fa-flag"></i>
                                </a></td>
                           
                        </tr>
                    </tbody>

                </table>
            </div>
        </div>

        <div class="modal fade" id="showCM">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="card-danger">
                        <div class="card-header">
                            <h3 class="card-title" id="card_title">ACTIVITY SUMMARY </h3>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="card-body">
                            <form class="register-form" [formGroup]='editmeetingform'
                                (ngSubmit)="updatedata(editmeetingform,CM_id)" autocomplete="off">
                                <div class="form-group row">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>First Name/ முதல் பெயர்</label><span class="required "> *</span>
                                        <input pInputText type="text" class="form-control" 
                                            placeholder="Enter First Name/ முதல் பெயர்" [value]="CM_name" readonly="readonly">
        
                                    </div>
                                        <div class="col-sm-6 mb-3 mb-sm-0">
                                            <label>Last Name / கடைசி பெயர்<span class="required "> *</span></label>
                                            <input pInputText type="text" class="form-control"  [value]="CM_lastname"
                                                placeholder="Enter Last Name / கடைசி பெயர்" readonly="readonly">
                                        
                                        </div>
                                    </div>
                                  
        
                                <div class="form-group row" >
                   
                                    <div class="col-sm-6">
                                        <label>Email / மின்னஞ்சல்<span class="required"> *</span></label>
                                        <input pInputText type="text" class="form-control" 
                                            [value]="CM_email" placeholder="Enter Email / மின்னஞ்சல்"
                                            readonly="readonly">
        
                                    </div>
                                        <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Status/ சமுதாயப் படிநிலை<span class="required "> *</span></label>
                                        <input type="text" class="form-control" [value]="CM_status"
                                            placeholder="Enter Status" readonly="readonly">
                                    
                                    </div>
                                </div>
                                <div class="form-group row">
                                                <div class="col-sm-6">
                                                    <label>District / மாவட்டம்<span class="required"> *</span></label>
                                                    <input pInputText type="text" class="form-control" [value]="CM_district" 
                                                        readonly="readonly">
                                                
                                                </div>
                                                <div class="col-sm-6 mb-3 mb-sm-0">
                                                    <label>Constituency/ வாக்காளர் தொகுதி<span class="required "> *</span></label>
                                                    <input type="text" class="form-control" [value]="CM_constituency" 
                                                        readonly="readonly">
                                                
                                                </div>
                                                </div>
                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-12 mb-3 mb-sm-0">
                                        <label>Comments / கருத்துரைகள்<span class="required "> *</span></label>
                                        <textarea type="date" class="form-control" [value]="CM_comments"
                                            ></textarea>
        
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <div class="col-sm-6 mb-3 mb-sm-0" *ngIf="CM_image1 !==''">
                                        <label>Image 1<span class="required "> *</span></label>
                                        <img src="https://redmindtechnologies.com/dmk_php-dhanasekar/{{CM_image1}}" style="width:100px;height:100px;display: block;" />
                                
                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0" *ngIf="CM_image2 !==''">
                                        <label>Image 2<span class="required "> *</span></label>
                                         <img src="https://redmindtechnologies.com/dmk_php-dhanasekar/{{CM_image2}}" style="width:100px;height:100px;display:block" />
                                    
                                    </div>
                                </div>
                                <div class="form-group row" >
                                    <div class="col-sm-6 mb-3 mb-sm-0" *ngIf="CM_image3 !==''">
                                        <label>Image 3<span class="required "> *</span></label>
                                        <img src="https://redmindtechnologies.com/dmk_php-dhanasekar/{{CM_image3}}" style="width:100px;height:100px;display:block" />
                                
                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0" *ngIf="CM_image4 !==''">
                                        <label>Image 4<span class="required "> *</span></label>
                                        <img src="https://redmindtechnologies.com/dmk_php-dhanasekar/{{CM_image4}}" style="width:100px;height:100px;display:block" />
                                
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-sm-6 mb-3 mb-sm-0" *ngIf="CM_image5 !==''">
                                        <label>Image 3<span class="required "> *</span></label>
                                        <img src="https://redmindtechnologies.com/dmk_php-dhanasekar/{{CM_image5}}" style="width:100px;height:100px;display:block" />
                                
                                    </div>
                                  
                                </div>
                                

        
                             
        
                            
        
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

       



        